import {
  ACCOUNTING_TIME_SHEETS_read,
  ACCOUNTING_TIME_SHEETS_create,
  // ACCOUNTING_TIME_SHEETS_update,
  ACCOUNTING_PAYROLL_BATCHES_read,
  ACCOUNTING_PAYROLL_BATCHES_create,
  ACCOUNTING_CONFIG_read,
  ACCOUNTING_CONFIG_GENERAL_read,
  ACCOUNTING_CONFIG_APPROVAL_PROCESS_read,
  ACCOUNTING_CONFIG_PAYROLL_TYPES_create,
  ACCOUNTING_CONFIG_PAYROLL_TYPES_READ,
  ACCOUNTING_CONFIG_PAYROLL_TYPES_UPDATE,
  ACCOUNTING_CONFIG_VALIDATION_RULES_create,
  // ACCOUNTING_CONFIG_VALIDATION_RULES_read,
  ACCOUNTING_PAYSLIPS_read,
} from "@/data/permission-types.js";
export const accounting = {
  path: "accounting",
  name: "accounting",
  component: () =>
    import(
      /* webpackChunkName: "accounting" */ "../../views/accounting/AccountingIndex.vue"
    ),
  meta: {
    requiresAuth: true,
    requiresPermission: true,
  },
  children: [
    // accounting > bookkeeping
    {
      path: "time-sheets",
      name: "accounting-time-sheets",
      component: () =>
        import(
          /* webpackChunkName: "accounting-time-sheets" */ "../../views/accounting/AccountingTimeSheets.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_TIME_SHEETS_read}`,
      },
    },
    // {
    //   path: "time-sheets-preview",
    //   name: "accounting-time-sheets-preview",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "accounting-time-sheets" */ "../../views/accounting/AccountingTimeSheetsNew.vue"
    //     ),
    //   meta: {
    //     requiresAuth: true,
    //     requiresPermission: true,
    //     permissionID: `${ACCOUNTING_TIME_SHEETS_read}`,
    //   },
    // },
    {
      path: "time-sheets-split",
      name: "accounting-time-sheets-split",
      component: () =>
        import(
          /* webpackChunkName: "accounting-time-sheets-split" */ "../../views/accounting/time-sheets/TimeSheetsSplitView.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_TIME_SHEETS_read}`,
      },
    },
    {
      path: "time-sheets/new",
      name: "accounting-time-sheets-new",
      component: () =>
        import(
          /* webpackChunkName: "accounting-time-sheets-manage" */ "../../views/accounting/time-sheets/TimeSheetNew.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_TIME_SHEETS_create}`,
      },
    },
    // {
    //   path: "time-sheets/:itemId/edit",
    //   name: "accounting-time-sheets-edit",
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "accounting-time-sheets-manage" */ "../../views/accounting/time-sheets/TimeSheetEdit.vue"
    //     ),
    //   meta: {
    //     requiresAuth: true,
    //     requiresPermission: true,
    //     permissionID: `${ACCOUNTING_TIME_SHEETS_update}`,
    //   },
    // },
    {
      path: "time-sheets/:itemId",
      name: "accounting-time-sheets-details",
      component: () =>
        import(
          /* webpackChunkName: "accounting-time-sheets-details" */ "../../views/accounting/time-sheets/TimeSheetDetails.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_TIME_SHEETS_read}`,
      },
    },
    // accounting > accounting
    {
      path: "payroll",
      name: "accounting-payroll",
      component: () =>
        import(
          /* webpackChunkName: "accounting-payroll" */ "../../views/accounting/AccountingPayroll.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_PAYROLL_BATCHES_read}`,
      },
    },
    {
      path: "payroll/new",
      name: "accounting-payroll-new",
      component: () =>
        import(
          /* webpackChunkName: "accounting-payroll-manage" */ "../../views/accounting/payroll/PayrollNew.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_PAYROLL_BATCHES_create}`,
      },
    },
    {
      path: "payroll/:itemId/export",
      name: "accounting-payroll-export",
      component: () =>
        import(
          /* webpackChunkName: "accounting-payroll-manage" */ "../../views/accounting/payroll/PayrollExport.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        // permissionID: `${ACCOUNTING_PAYROLL_update}`,
      },
    },
    {
      path: "payroll/:itemId",
      name: "accounting-payroll-details",
      component: () =>
        import(
          /* webpackChunkName: "accounting-payroll-manage" */ "../../views/accounting/payroll/PayrollDetails.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_PAYROLL_BATCHES_read}`,
      },
    },
    // accounting > payslips
    {
      path: "payslips",
      name: "accounting-payslips",
      component: () =>
        import(
          /* webpackChunkName: "accounting-payslips" */ "../../views/accounting/AccountingPayslips.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_PAYSLIPS_read}`,
      },
    },
    {
      path: "payslips/:itemId",
      name: "accounting-payslips-details",
      component: () =>
        import(
          /* webpackChunkName: "accounting-payslips-manage" */ "../../views/accounting/payslips/PayslipDetails.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_PAYSLIPS_read}`,
      },
    },
    // accounting > reports
    {
      path: "reports",
      name: "accounting-reports",
      component: () =>
        import(
          /* webpackChunkName: "accounting-reports" */ "../../views/accounting/AccountingReports.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        // permissionID: `${ACCOUNTING_PAYROLL_read}`,
      },
    },
    {
      path: "archive",
      name: "accounting-archive",
      component: () =>
        import(
          /* webpackChunkName: "accounting-archive" */ "../../views/accounting/AccountingArchive.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        // permissionID: `${ACCOUNTING_PAYROLL_read}`,
      },
      children: [
        {
          path: "time-sheets",
          name: "accounting-archive-tab-time-sheets",
          component: () =>
            import(
              /* webpackChunkName: "accounting-archive" */ "../../views/accounting/archive/ArchiveTabTimeSheets.vue"
            ),
          meta: {
            requiresAuth: true,
            requiresPermission: true,
            // permissionID: `${ACCOUNTING_CONFIG_GENERAL_read}`,
          },
        },
        {
          path: "payslips",
          name: "accounting-archive-tab-payslips",
          component: () =>
            import(
              /* webpackChunkName: "accounting-archive" */ "../../views/accounting/archive/ArchiveTabPayslips.vue"
            ),
          meta: {
            requiresAuth: true,
            requiresPermission: true,
            // permissionID: `${ACCOUNTING_CONFIG_GENERAL_read}`,
          },
        },
        {
          path: "payroll",
          name: "accounting-archive-tab-payroll",
          component: () =>
            import(
              /* webpackChunkName: "accounting-archive" */ "../../views/accounting/archive/ArchiveTabPayroll.vue"
            ),
          meta: {
            requiresAuth: true,
            requiresPermission: true,
            // permissionID: `${ACCOUNTING_CONFIG_GENERAL_read}`,
          },
        },
      ],
    },
    // accounting > config
    {
      path: "config",
      name: "accounting-config",
      component: () =>
        import(
          /* webpackChunkName: "accounting-config" */ "../../views/accounting/AccountingConfig.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_CONFIG_read}`,
      },
      children: [
        {
          path: "general",
          name: "accounting-config-tab-general",
          component: () =>
            import(
              /* webpackChunkName: "accounting-config" */ "../../views/accounting/config/ConfigTabGeneral.vue"
            ),
          meta: {
            requiresAuth: true,
            requiresPermission: true,
            permissionID: `${ACCOUNTING_CONFIG_GENERAL_read}`,
          },
        },
        {
          path: "payroll-types",
          name: "accounting-config-tab-payroll-types",
          component: () =>
            import(
              /* webpackChunkName: "accounting-config" */ "../../views/accounting/config/ConfigTabPayrollTypes.vue"
            ),
          meta: {
            requiresAuth: true,
            requiresPermission: true,
            permissionID: `${ACCOUNTING_CONFIG_PAYROLL_TYPES_READ}`,
          },
        },
        {
          path: "approval-process",
          name: "accounting-config-tab-approval-process",
          component: () =>
            import(
              /* webpackChunkName: "accounting-config" */ "../../views/accounting/config/ConfigTabApprovalProcess.vue"
            ),
          meta: {
            requiresAuth: true,
            requiresPermission: true,
            permissionID: `${ACCOUNTING_CONFIG_APPROVAL_PROCESS_read}`,
          },
        },
        {
          path: "validation",
          name: "accounting-config-tab-validation",
          component: () =>
            import(
              /* webpackChunkName: "accounting-config" */ "../../views/accounting/config/ConfigTabValidation.vue"
            ),
          meta: {
            requiresAuth: true,
            requiresPermission: true,
            // permissionID: `${ACCOUNTING_CONFIG_GENERAL_read}`,
          },
        },
      ],
    },
    {
      path: "config/validation/validation-rules/new",
      name: "accounting-config-tab-validation-validation-rules-new",
      component: () =>
        import(
          /* webpackChunkName: "accounting-config" */ "../../views/accounting/config/validation/ValidationRuleNew.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_CONFIG_VALIDATION_RULES_create}`,
      },
    },
    {
      path: "config/payroll-types/:itemId/edit",
      name: "accounting-config-tab-payroll-types-payroll-type-edit",
      component: () =>
        import(
          /* webpackChunkName: "accounting-config" */ "../../views/accounting/config/payroll-types/PayrollTypeEdit.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_CONFIG_PAYROLL_TYPES_UPDATE}`,
      },
    },
    {
      path: "config/payroll-types/new",
      name: "accounting-config-tab-payroll-types-payroll-type-new",
      component: () =>
        import(
          /* webpackChunkName: "accounting-config" */ "../../views/accounting/config/payroll-types/PayrollTypeNew.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_CONFIG_PAYROLL_TYPES_create}`,
      },
    },
    {
      path: "config/payroll-types/:itemId/edit",
      name: "accounting-config-tab-payroll-types-payroll-type-edit",
      component: () =>
        import(
          /* webpackChunkName: "accounting-config" */ "../../views/accounting/config/payroll-types/PayrollTypeEdit.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_CONFIG_PAYROLL_TYPES_UPDATE}`,
      },
    },
    {
      path: "config/payroll-groups/new",
      name: "accounting-config-tab-payroll-types-payroll-group-new",
      component: () =>
        import(
          /* webpackChunkName: "accounting-config" */ "../../views/accounting/config/payroll-groups/PayrollGroupNew.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_CONFIG_PAYROLL_TYPES_create}`,
      },
    },
    {
      path: "config/payroll-groups/:itemId/edit",
      name: "accounting-config-tab-payroll-types-payroll-group-edit",
      component: () =>
        import(
          /* webpackChunkName: "accounting-config" */ "../../views/accounting/config/payroll-groups/PayrollGroupEdit.vue"
        ),
      meta: {
        requiresAuth: true,
        requiresPermission: true,
        permissionID: `${ACCOUNTING_CONFIG_PAYROLL_TYPES_UPDATE}`,
      },
    },
  ],
};
